// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { FooterMenuFragmentDoc } from './FooterMenu.fragment.generated';
import { ImageLargeFragmentDoc } from '../../cms/imageLarge.fragment.generated';
export const FooterFragmentDoc = gql`
    fragment footer on Footer {
  columns {
    ...footerMenu
  }
  copyright
  logos {
    link
    logo {
      ...imageLarge
    }
  }
}
    ${FooterMenuFragmentDoc}
${ImageLargeFragmentDoc}`;